import { render, staticRenderFns } from "./SetOnoff.vue?vue&type=template&id=0a289dfd&"
import script from "./SetOnoff.vue?vue&type=script&lang=js&"
export * from "./SetOnoff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports